export default __webpack_public_path__ + "static/2439-f3142c08ae3ce045b2d2b6368d98e665.gif";